import type { ComponentProps } from 'react'

import { Logo } from './Logo'

type Props = ComponentProps<typeof Logo>

export const ProductLogo = (props: Props) => <Logo {...props} />
